// extracted by mini-css-extract-plugin
module.exports = {"container":"CardBrandList_container__De3iK","logo_wrapper":"CardBrandList_logo_wrapper__Wvpqs"};